import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getSrpMobileSidebarOpen } from 'redux-implementations/selectors';
import { toggleSrpSidebarOpen } from 'redux-implementations/srpFilters';

export interface UseSrpMobileSidebarResult {
  isOpen: boolean;
  toggle: () => void;
}

export default function useSrpMobileSidebar(): UseSrpMobileSidebarResult {
  const isOpen = useSelector(getSrpMobileSidebarOpen);
  const dispatch = useDispatch();
  const toggle = useCallback((): void => {
    dispatch(toggleSrpSidebarOpen());
  }, [dispatch]);

  return {
    isOpen,
    toggle,
  };
}
